// extracted by mini-css-extract-plugin
export default {"label":"RatingInput-module-f8ae918454032b363d11"};